export default __webpack_public_path__ + "static/media/heroku.68909cda.svg";